import { Router } from '@angular/router';
import { AuthService } from './../../../core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hide = true;
  loginForm = new FormGroup({
    userName: new FormControl('', [
      Validators.required
    ]),
    password: new FormControl('', [Validators.required])

  })
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    if(this.authService.currentUserValue){
      this.router.navigate(['/home']);
    }
  }

  submit() {
    this.authService.loginService(this.loginForm.value);
  }

  goToTerms() {
     window.open(`${window.location.origin}/tpa/t&c`, '_blank');
  }
}
